export default "__VITE_ASSET__DU0QjPV8__"